/**
 * Location view (S17 direct PoI visit).
 *
 * One slice of the base-view stylesheet. `styles/index.ts` concatenates
 * every slice into the single sheet `injectStyles` mounts — the split is
 * about OWNERSHIP, not about emitting more than one style element.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below
 * is one template literal and a stray backtick terminates it. That has
 * broken the build twice, both times with esbuild pointing at a line ten
 * rows away from the cause. Write class names in plain text.
 */
export default `
/* ── Location (S17 direct PoI visit) ──────────────────────────────────── */
.bv-loc-exit {
  position: absolute; top: 12px; left: 12px; z-index: 5;
  font: 700 12px var(--font-display); text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--bone); background: rgba(20,12,7,0.8); border: 1px solid var(--line);
  border-radius: var(--radius-well); padding: 8px 14px; cursor: pointer;
}
.bv-loc-exit:hover { color: var(--brass-hot); border-color: var(--brass); }
.bv-loc-toast {
  position: absolute; left: 50%; bottom: 64px; transform: translateX(-50%); z-index: 6;
  font: 12px var(--font-technical); color: var(--bone); letter-spacing: 0.03em;
  background: rgba(20,12,7,0.85); border: 1px solid var(--line);
  border-radius: var(--radius-well); padding: 8px 16px; max-width: 70%; text-align: center;
}
.bv-loc-toast[hidden] { display: none; }
`;
